import { render, staticRenderFns } from "./MyQuestionDetail.vue?vue&type=template&id=0b9dd758&scoped=true&"
import script from "./MyQuestionDetail.vue?vue&type=script&lang=js&"
export * from "./MyQuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyQuestionDetail.vue?vue&type=style&index=0&id=0b9dd758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9dd758",
  null
  
)

export default component.exports